import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from '../icons';

type BackButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
};

type ContinueButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  label?: string;
  className?: string;
};

type CTAGroupProps = {
  onBack: () => void;
  onContinue: () => void;
  isLoading?: boolean;
  continueLabel?: string;
  continueDisabled?: boolean;
  className?: string;
};

export function BackButton({ onClick, disabled, className = '' }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Go back"
      className={`flex h-[54px] shrink-0 items-center justify-center px-[20px] py-[18px] rounded-full border border-onboarding-card-green text-onboarding-card-green transition-colors hover:bg-onboarding-card-green/5 disabled:opacity-50 disabled:pointer-events-none ${className}`}
    >
      <ArrowLeftIcon />
    </button>
  );
}

export function ContinueButton({
  onClick,
  disabled,
  isLoading,
  label = 'Continue',
  className = ''
}: ContinueButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`flex h-[54px] flex-1 items-center justify-center gap-2 rounded-full bg-onboarding-card-green text-onboarding-text-light transition-colors hover:bg-onboarding-card-green/90 disabled:opacity-50 disabled:pointer-events-none ${className}`}
    >
      <span className="font-helvetica text-base leading-[1.6] tracking-[-0.08px]">{isLoading ? 'Saving...' : label}</span>
      {!isLoading && <ArrowRightIcon />}
    </button>
  );
}

export function CTAGroup({
  onBack,
  onContinue,
  isLoading,
  continueLabel,
  continueDisabled,
  className = ''
}: CTAGroupProps) {
  return (
    <div className={`flex items-center gap-[12px] ${className}`}>
      <BackButton onClick={onBack} />
      <ContinueButton
        onClick={onContinue}
        isLoading={isLoading}
        disabled={continueDisabled}
        label={continueLabel}
      />
    </div>
  );
}
